// notify the user using live regions
function notifyUser(message) {
  var notifications = document.getElementById("notifications");
  if (notifications) {
    notifications.innerHTML =
      "<div role='alert' class='alert'>" + message + "</div>";
  }
}
